import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import Account from 'modules/Account';
import App from 'modules/App';
import { useAction } from 'hooks';
const { selectors, messages } = Account;
const { actions } = App;
const AccountDeleteCheck = ()=>{
    const isAccountScheduledForDeletion = useSelector(selectors.isAccountScheduledForDeletion);
    const showAlert = useAction(actions.setAlert);
    useEffect(()=>{
        if (isAccountScheduledForDeletion) {
            showAlert({
                type: 'warning',
                message: messages.alerts.accountIsToBeDeleted
            });
        }
    }, [
        isAccountScheduledForDeletion
    ]);
    return null;
};
export default AccountDeleteCheck;
